import {defaultActionCreator} from "./actionCreator";

export const GET_ACCOUNT_REQUEST = 'GET_ACCOUNT_REQUEST'
export const getAccountRequest = defaultActionCreator(GET_ACCOUNT_REQUEST, 'data')